import { useState, useEffect } from "react";
import { Button } from "components/ui/button";
import { Check } from "lucide-react";

export default function SelectRadioMultipleTick({
  value,
  items,
  onValueChange,
  isSplitWithComma = false,
}: {
  onValueChange: (selected: string) => void;
  items: string[];
  value?: string;
  isSplitWithComma?: boolean;
}) {
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);

  // Update selectedCategories if the value prop changes
  useEffect(() => {
    if (value) {
      const selectedValues = value
        .split(isSplitWithComma ? ", " : "|")
        .map((item) => item.trim());
      setSelectedCategories(selectedValues);
    }
  }, [value]);

  const handleClick = (category: string) => {
    setSelectedCategories((prevState) =>
      prevState.includes(category)
        ? prevState.filter((item) => item !== category)
        : [...prevState, category]
    );
  };

  const categoriesString = selectedCategories.join(
    isSplitWithComma ? ", " : "|"
  );

  // Sync selected categories with the parent component
  useEffect(() => {
    onValueChange(categoriesString);
  }, [selectedCategories, onValueChange]);

  return (
    <>
      {items?.map((element, index) => (
        <div key={index} className="">
          <Button
            className={`bg-neutral-100 hover:bg-[#E5E5E5] text-black px-3 rounded-md mt-2 flex justify-between w-full ${
              selectedCategories.includes(element) ? "" : ""
            }`}
            id={`interest-btn-${element}`}
            onClick={() => handleClick(element)}
          >
            {element}
            {selectedCategories.includes(element) && <Check className="" />}
          </Button>
        </div>
      ))}
    </>
  );
}
